import React from 'react';
import PropTypes from 'prop-types';

import {
  getPassthroughProps
} from '../componentHelpers.js';

import FormFieldLayout from './FormFieldLayout.jsx';
import Spinner from '../Spinner.jsx';
import withValidation from './withValidation';

class FormField extends React.PureComponent {
  get isShowingValidation() {
    return !this.props.suppressValidationDisplay
      && (this.props.hasSubmitted || this.props.wasVisited);
  }

  get hasValue() {
    let { value } = this.props;
    return value !== null && value !== '' && !Number.isNaN(value);
  }

  get validationPassed() {
    return this.props.isValidated && this.props.validationState === 'success';
  }

  get displayValidationState() {
    if (this.isShowingValidation && this.props.validationState === 'error') {
      return 'error';
    }
    else if (this.isShowingValidation && this.props.willShowSuccessValidation && this.validationPassed && this.hasValue) {
      return 'success';
    }
    else {
      return null;
    }
  }

  get validationIcon() {
    if (this.isShowingValidation && this.props.isValidating && this.hasValue) {
      return <span><Spinner /></span>;
    }
    else if (this.isShowingValidation && this.props.willShowSuccessValidation && this.validationPassed && this.hasValue) {
      return <i className="icon-check-circle"></i>;
    }
    else if (this.isShowingValidation && (this.props.validationState === 'error')) {
      return <i className="icon-error"></i>;
    }
    else {
      return null;
    }
  }

  render() {
    let {
      children,
      label,
      layout: Layout = FormFieldLayout,
      shareValidationState,
      validationMessage,
    } = this.props;

    return (
      <Layout {...getPassthroughProps(this)}
        validationMessage={this.isShowingValidation ? validationMessage : null}
        label={label}
        validationIcon={this.validationIcon}
        validationState={this.displayValidationState}
        value={this.props.value}
      >
        {
          shareValidationState
            ? React.Children.map(children, child =>  React.cloneElement(child, { validationState: this.displayValidationState }))
            : children
        }
      </Layout>
    );
  }
}

FormField.propTypes = {
  hasSubmitted: PropTypes.bool,
  isValidating: PropTypes.bool,
  isValidated: PropTypes.bool,
  label: PropTypes.node,
  layout: PropTypes.func,
  shareValidationState: PropTypes.bool,
  suppressValidationDisplay: PropTypes.bool,
  validationMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  validationState: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  wasVisited: PropTypes.bool,
  willShowSuccessValidation: PropTypes.bool
};

FormField.defaultProps = {
  shareValidationState: false,
  suppressValidationDisplay: false,
  wasVisited: false,
  willShowSuccessValidation: true
};

let validatedFormField = withValidation(FormField);

export default validatedFormField;
